// extracted by mini-css-extract-plugin
export default {"input":"AddHotelForm_input__MDt8k","errored":"AddHotelForm_errored__bTZAF","error":"AddHotelForm_error__LDzoE"};